<div class="page-content">
  <!-- Page Header-->
  <div class="page-header no-margin-bottom">
    <div class="container-fluid">
      <h2 class="h5 no-margin-bottom">{{ category | uppercase }}</h2>
    </div>
  </div>

  <section class="no-padding-top">
    <div fxLayout="row wrap" fxLayoutGap="16px">
      <div class="row mt-10">
        <ng-container *ngIf="videos$ | async">
          <div class="card col-md-3 col-xs-12 col-sm-6" *ngFor="let item of videos$ | async; let i = index">
            <div class="video-item">
              <div [innerHtml]="videoHtml(item.link)"></div>
              <div #player_container></div>
              <div class="card-body">
                <h5 class="card-title">{{ item.title }}</h5>
                <span class="card-category" [routerLink]="['/video/category/' + item.category.slug]">{{
                  item.category.name
                }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </section>
</div>
